import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { weischerAdUpdateItem } from '../../../actions/index'
import toJS from '../../../hoc/toJS'
import getData from '../../../functions/getData'
import { CLI_CINEMA_CLIENT_ID, PROGRAM_CINEMAS, PROGRAM_WEISCHERAD_ITEMS } from '../../../constants/state'
import EditWeischerAd from '../present/EditWeischerAd'
import { push } from 'connected-react-router'

const mapStateToProps = (state, ownProps) => ({
    itemData: getData(state, [PROGRAM_WEISCHERAD_ITEMS, ownProps.itemId]),
    cliCinemas: getData(state, PROGRAM_CINEMAS),
    clientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    onUpdateItem: itemData => {
        dispatch(weischerAdUpdateItem(ownProps.itemId, itemData))
        dispatch(push(ownProps.closePagePath))
    }
})

const EditWeischerAdContainer = ({itemData, closePagePath, onUpdateItem, cliCinemas, clientCinemaId}) => <EditWeischerAd
    itemData={itemData}
    closePagePath={closePagePath}
    onUpdateItem={onUpdateItem}
    cliCinemas={cliCinemas}
    clientCinemaId={clientCinemaId}
    weischerType={'main'}
/>

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(EditWeischerAdContainer)